/**
 * A dummy empty function
 */
const dummyFunction = () => {};

export default dummyFunction;
